import { Box, Button, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import ConfirmStartDialog from "../sections/receiving/ConfirmStartDialog";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function ProductSyncSection() {
  const [lastSync, setLastSync] = useState(null);
  const [refreshDisabled, setRefreshDisabled] = useState(false);
  const [confirmStart, setConfirmStart] = useState(false);

  const authContext = useContext(AuthContext)

  const findLastSync = async () => {
    try {
      const res = await fetchWithInterceptor(`/api/receiving/last-sync`, {
        method: "GET",
        headers: {
          "x-access-token": authContext.getToken(),
        },
      });

      if (res.ok) {
        const data = await res.json();
        setLastSync(data);
      }
    } catch (err) {
      console.error("Error fetching last sync", err);
    }
  };

  useEffect(() => {
    findLastSync();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRefresh = async () => {
    setRefreshDisabled(true);
    await findLastSync();
    setTimeout(() => setRefreshDisabled(false), 15000);
  };

  const hideConfirmStart = () => {
    setConfirmStart(false);
    handleRefresh();
  };

  const renderLastSync = () => {
    if (lastSync?.isSyncing) {
      return <Typography>Last sync: In progress...</Typography>;
    }
    if (lastSync?.syncedAt) {
      return (
        <Typography>
          Last sync: {new Date(lastSync.syncedAt).toLocaleString()}
        </Typography>
      );
    }
    return <Typography>Last sync: Never</Typography>;
  };

  const renderSyncButton = () => {
    if (lastSync?.isSyncing) {
      return (
        <Button
          variant="outlined"
          color="primary"
          onClick={handleRefresh}
          disabled={refreshDisabled}
        >
          Refresh
        </Button>
      );
    }
    return (
      <Button
        variant="outlined"
        color="primary"
        onClick={() => setConfirmStart(true)}
        disabled={refreshDisabled}
      >
        Sync Now
      </Button>
    );
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        flexDirection={{ xs: "column", sm: "row" }}
      >
        {renderLastSync()}
        {renderSyncButton()}
      </Box>
      <ConfirmStartDialog open={confirmStart} onClose={hideConfirmStart} />
    </>
  );
}